<script lang="ts">
      import { getLocaleContext } from '$lib/components/locale/ts/Locale.svelte'
      import { addComma, renderEntity, roleAggregation } from '../ts/Program'

      let locale = getLocaleContext()

      let { roles, title } = $props()
</script>

<div class="flex flex-col bg-[#f2F2F2] w-full h-max p-4 md:p-8 rounded-2xl shadow-md gap-1">
      <div class="text-accent text-xl mb-4 font-[300]">{title}</div>
      {#each roleAggregation(roles) as role, i}
            <div class="flex flex-row font-[300]">
                  <p>
                        {#if role.role?.replace(/ +$/, '')}
                              <span class="mr-1 text-nowrap">
                                    {role.role}:
                              </span>
                        {/if}
                        <span class=" w-auto font-['nunito-sans']">
                              <!--{role.names}-->
                              {#each role._entities as ent, o}
                                    {@const entityObject = renderEntity(ent)}
                                    {#if entityObject.url}
                                          <a class="df-link" href={locale.getLocaleLink(entityObject.url)}>{entityObject.title}</a>
                                    {:else}
                                          {entityObject.title}
                                    {/if}
                                    {addComma(o, role._entities.length)}
                              {/each}
                        </span>
                  </p>
            </div>
      {/each}
</div>
<!-- 
     -->
